type PunchCoordinates = {
  latitude: number;
  longitude: number;
  gpsAccuracyMeters: number | null;
};

type GeoPosition = {
  coords?: {
    latitude?: number;
    longitude?: number;
    accuracy?: number;
  };
};

function readNavigatorGeolocation(): {
  getCurrentPosition: (
    success: (position: GeoPosition) => void,
    error?: () => void,
    options?: { enableHighAccuracy?: boolean; timeout?: number; maximumAge?: number },
  ) => void;
} | null {
  const geo = (
    globalThis as { navigator?: { geolocation?: { getCurrentPosition?: unknown } } }
  ).navigator?.geolocation;
  if (!geo || typeof geo.getCurrentPosition !== 'function') return null;
  return geo as {
    getCurrentPosition: (
      success: (position: GeoPosition) => void,
      error?: () => void,
      options?: { enableHighAccuracy?: boolean; timeout?: number; maximumAge?: number },
    ) => void;
  };
}

/** Best-effort GPS for Office vs Manual. Punch still proceeds if location is missing. */
export function readPunchCoordinates(): Promise<PunchCoordinates | null> {
  const geo = readNavigatorGeolocation();
  if (!geo) return Promise.resolve(null);

  return new Promise(resolve => {
    const finish = (value: PunchCoordinates | null) => resolve(value);
    const timer = setTimeout(() => finish(null), 8000);
    geo.getCurrentPosition(
      position => {
        clearTimeout(timer);
        const latitude = Number(position?.coords?.latitude);
        const longitude = Number(position?.coords?.longitude);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          finish(null);
          return;
        }
        const accuracy = Number(position?.coords?.accuracy);
        finish({
          latitude,
          longitude,
          gpsAccuracyMeters: Number.isFinite(accuracy) ? accuracy : null,
        });
      },
      () => {
        clearTimeout(timer);
        finish(null);
      },
      { enableHighAccuracy: true, timeout: 7000, maximumAge: 15000 },
    );
  });
}
